import { render } from "./TouchScreen.vue?vue&type=template&id=1264aaf0&scoped=true"
import script from "./TouchScreen.vue?vue&type=script&scoped=true&lang=js"
export * from "./TouchScreen.vue?vue&type=script&scoped=true&lang=js"

import "./TouchScreen.vue?vue&type=style&index=0&id=1264aaf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1264aaf0"]])

export default __exports__